var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_171_979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8106 2.49808L20.5098 18.0645C20.2608 19.1631 19.6114 19.4366 18.6885 18.919L13.6592 15.2129L11.2325 17.5469C10.9639 17.8155 10.7393 18.0401 10.2217 18.0401L10.5831 12.918L19.9044 4.49515C20.3096 4.13382 19.8165 3.93362 19.2745 4.29495L7.75103 11.5508L2.7901 9.99808C1.71099 9.66116 1.69146 8.91897 3.01471 8.4014L22.419 0.92581C23.3174 0.588896 24.1036 1.12601 23.8106 2.49808Z",
    fill: "#ECB956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7867 2.49301L23.7867 2.49298C23.9323 1.81111 23.8083 1.34403 23.5446 1.08861C23.2813 0.833564 22.8712 0.782372 22.4277 0.94861C22.4277 0.94863 22.4276 0.94865 22.4276 0.94867L3.0236 8.42413C3.02357 8.42414 3.02355 8.42415 3.02353 8.42416C2.69438 8.55291 2.4503 8.69505 2.28577 8.84016C2.12109 8.9854 2.03792 9.1319 2.02584 9.26962C2.01384 9.40655 2.07167 9.54016 2.20059 9.66146C2.32987 9.7831 2.52966 9.89119 2.79737 9.97477L2.79739 9.97478L7.74757 11.5241L19.2609 4.27464C19.261 4.27458 19.2611 4.27452 19.2612 4.27446C19.3988 4.18275 19.5339 4.12628 19.6531 4.09918C19.772 4.07216 19.8768 4.07395 19.9528 4.10106C20.0297 4.12845 20.0803 4.18372 20.0775 4.26149C20.0749 4.33551 20.0236 4.42155 19.9207 4.51326L23.7867 2.49301ZM23.7867 2.49301L20.486 18.0591C20.486 18.0592 20.486 18.0592 20.486 18.0593C20.3621 18.6055 20.1403 18.9393 19.8417 19.0756C19.5435 19.2117 19.1598 19.155 18.7018 18.8984L13.6737 15.1933L13.6571 15.1811L13.6423 15.1953L11.2156 17.5293L11.2152 17.5296C11.0805 17.6643 10.9594 17.7852 10.8082 17.8731C10.6631 17.9574 10.4891 18.0118 10.2479 18.0155L10.6067 12.9295L19.9206 4.51337L23.7867 2.49301Z",
    stroke: "#ECB956",
    strokeWidth: 0.0488281
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_171_979",
    x: -0.00012207,
    y: 0.828125,
    width: 25.873,
    height: 24.3438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_171_979"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_171_979",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a8c780648a3260c3257a34077d6865c4.svg";
export { ForwardRef as ReactComponent };